/*
* Scope: Singleton
* Event Registry wil store the events as callback for certain actions / events.
* This saves the browser from throwing undefined in case of missing functions as the events are used instead.
* However, it is up to the developer to not miss any function while registering the appropriate functions.
*/
var HmEventRegistry = function () {
    var eventRegistry = {};
    return{
		/**
		 * Registering Event
		 */
		registerEvent:function(eventName, eventHandler){
			if(eventName !== null && eventHandler !== null){
				eventRegistry[eventName] = eventHandler;
				return true;
			}else{
				return false;
			}
		},
		/**
		* function to check if the event exists
		*/
		exists: function(eventName){
			return (eventName && eventRegistry[eventName]);			
		},
		/**
		 * Firing the registered Event
		 */
		fireEvent:function(eventName){
			var eventParams = [];
		
			if(arguments && arguments.length > 1){
				for(var i =1; i< arguments.length; i++){
					eventParams.push(arguments[i]);
				}
			}
			
			if(eventName !== null){
				if(eventRegistry[eventName]){
					if(typeof eventRegistry[eventName] === "function"){
						return eventRegistry[eventName].apply(this, eventParams);
					}else{
						return eventRegistry[eventName];
					}
				}else{
					return {};
				}
			}
		}
	};
}();

export default HmEventRegistry;


// WEBPACK FOOTER //
// ./src/model/HmEventRegistry.js